<template>
    <div class="search-whole-page-background" @click="$emit('click', $event)"></div>
</template>

<script>
export default {
    name: "SearchWholePageBackground",
    emits: ['click']
}
</script>

<style scoped>
    .search-whole-page-background {
        position: fixed;
        z-index: 5;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
</style>